// This file is auto-generated. Edit data.json to change it.
import { DataProvider } from 'Simple/Data'
import useDataOnChange from './useDataOnChange'
import rdata from './data.json'
import React from 'react'
import Logic from './logic'

/** @type {import('Simple/types.js').Data} */
export default function TasksCreateFormData(props) {
  let data = rdata.value
  let onChange = useDataOnChange(props, data)

  return (
    <DataProvider
      context="form"
      value={data}
      viewPath={props.viewPath}
      onChange={onChange}
    >
      <Logic {...props} />
    </DataProvider>
  )
}